const perks = [
  { icon: "ri-time-line", text: "热点发生 30 分钟内推送到手" },
  { icon: "ri-file-list-3-line", text: "完整时间线与出处，随时往回翻" },
  { icon: "ri-notification-3-line", text: "你关注的事件，进展第一时间提醒" },
];

export default function AppDownload() {
  return (
    <section id="download" className="w-full bg-background-50 px-4 md:px-8 pb-16 md:pb-24">
      <div className="max-w-shell mx-auto">
        <div className="relative w-full rounded-lg overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=abstract%20warm%20amber%20gradient%20light%20rays%20through%20a%20dark%20charcoal%20room%20with%20floating%20paper%20pages%2C%20cinematic%20haze%2C%20large%20empty%20dark%20negative%20space%20for%20text%2C%20artistic%20conceptual%20photography%2C%20no%20text%2C%20high%20detail&width=1600&height=700&seq=hlkd-cta-01&orientation=landscape"
            alt="黑料看点 App 下载 深度解读"
            title="下载黑料看点 App"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/92 via-foreground-950/80 to-foreground-950/55" />

          <div className="relative z-10 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center p-6 md:p-12 lg:p-14">
            <div className="lg:col-span-7">
              <span className="inline-flex items-center gap-2 rounded-full border border-primary-300/50 bg-primary-500/10 px-3.5 py-1 text-xs text-primary-200">
                <i className="ri-smartphone-line" />
                黑料看点 App
              </span>
              <h2 className="mt-5 font-heading text-2xl md:text-4xl font-bold text-background-50 leading-snug">
                把每一次复盘，都装进口袋
              </h2>
              <p className="mt-4 max-w-xl text-sm md:text-base text-background-200 leading-relaxed">
                在 App 里，时间线可以逐节点展开、每条出处随手点开、观点碰撞按立场筛选。
                比网页更完整，也更适合慢慢看。
              </p>

              <ul className="mt-6 space-y-2.5">
                {perks.map((p) => (
                  <li key={p.text} className="flex items-center gap-2.5 text-sm text-background-100">
                    <span className="w-6 h-6 rounded-md bg-background-50/10 flex items-center justify-center">
                      <i className={`${p.icon} text-primary-300 text-sm`} />
                    </span>
                    {p.text}
                  </li>
                ))}
              </ul>

              <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                <button
                  type="button"
                  className="whitespace-nowrap inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-6 py-3 transition-colors cursor-pointer"
                >
                  <i className="ri-apple-fill text-lg" />
                  iOS 版下载
                </button>
                <button
                  type="button"
                  className="whitespace-nowrap inline-flex items-center justify-center gap-2 rounded-md border border-background-50/35 hover:border-background-50/70 text-background-50 text-sm font-medium px-6 py-3 transition-colors cursor-pointer"
                >
                  <i className="ri-android-fill text-lg" />
                  Android 版下载
                </button>
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="max-w-xs mx-auto lg:ml-auto lg:mr-0 rounded-lg border border-background-50/15 bg-background-50/8 backdrop-blur p-5 text-center">
                <div className="mx-auto w-32 h-32 rounded-md bg-background-50 flex items-center justify-center">
                  <i className="ri-qr-code-line text-6xl text-foreground-900" />
                </div>
                <p className="mt-4 text-sm text-background-100">扫码下载 App</p>
                <p className="mt-1 text-xs text-background-300">支持 iOS 与 Android</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}